/* VICO — vico-luxe.js · reveal on scroll das seções vico-* (par do vico-luxe.css).
   Marca html.vlx-ready, aplica .vlx com --vlx-d escalonado nos alvos reais das
   seções (galeria, hero, split) e revela com IntersectionObserver, uma vez só.
   Sem IO, com reduced-motion ou com erro, tudo fica visível — nada some. */
(function () {
  'use strict';
  try {
    var root = document.documentElement;
    root.classList.add('vlx-ready');
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* seção (classe real do liquid) -> filhos que entram em cena */
    var MAPA = [
      ['.vico-gl', '.vico-gl__head, .vico-gl__tile'],
      ['.vico-eh', '.vico-eh__cta'],
      ['.vico-sp', '.vico-sp__eyebrow, .vico-sp__h, .vico-sp__b, .vico-sp__cta']
    ];

    var io = null;
    if (!reduce && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('vlx-in');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }

    function marcar(escopo) {
      MAPA.forEach(function (par) {
        var secoes = (escopo || document).querySelectorAll(par[0]);
        Array.prototype.forEach.call(secoes, function (sec) {
          var alvos = sec.querySelectorAll(par[1]);
          Array.prototype.forEach.call(alvos, function (el, i) {
            if (el.classList.contains('vlx')) { return; }
            el.classList.add('vlx');
            el.style.setProperty('--vlx-d', (i * 90) + 'ms');
            if (io) { io.observe(el); } else { el.classList.add('vlx-in'); }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { marcar(document); });
    } else {
      marcar(document);
    }
    /* editor de tema: seção recarregada entra de novo no ciclo */
    document.addEventListener('shopify:section:load', function (e) { marcar(e.target); });
  } catch (err) {
    /* qualquer falha: desliga o estado escondido — conteúdo sempre visível */
    try { document.documentElement.classList.remove('vlx-ready'); } catch (e2) {}
  }
})();


/* Mega menu VIVO (pedido 31/08): o card da direita troca conforme o item sob o
   mouse — imagem de CENA REAL da casa (Conteúdo > Arquivos), nome do link e o
   link do card. Sem preço, sem claim: card de coleção, não de oferta. */
(function () {
  'use strict';
  try {
    var CDN = 'https://cdn.shopify.com/s/files/1/0745/3602/6182/files/';
    var V1 = '?v=1785888146', V2 = '?v=1786570719', V3 = '?v=1786582984';
    var MAPA = {
      'Limpeza':                { img: 'vico-cena-limpeza-vidro.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Cleansing':              { img: 'vico-cena-limpeza-vidro.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Tônicos e essências':    { img: 'vico-cena-finder-agua.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Toners and essences':    { img: 'vico-cena-finder-agua.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Séruns e tratamentos':   { img: 'vico-cena-serum-textura.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Serums and treatments':  { img: 'vico-cena-serum-textura.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Hidratação e barreira':  { img: 'vico-cena-hidratacao-creme.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Hydration and barrier':  { img: 'vico-cena-hidratacao-creme.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Máscaras':               { img: 'vico-cena-mascaras-produto.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Masks':                  { img: 'vico-cena-mascaras-produto.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Esfoliação':             { img: 'vico-cena-textura-gel.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Exfoliation':            { img: 'vico-cena-textura-gel.png' + V1, k: (window.vicoThemeI18n?.s_17829a18a29a ?? "RITUAL STEP") },
      'Oleosa e poros':         { img: 'vico-cena-hidrogel.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Oily skin and pores':    { img: 'vico-cena-hidrogel.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Sensível e vermelhidão': { img: 'vico-cena-hero-seda.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Sensitive skin and redness': { img: 'vico-cena-hero-seda.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Desidratada e barreira': { img: 'vico-cena-rotina-manha.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Dehydrated skin and barrier': { img: 'vico-cena-rotina-manha.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Textura e viço':         { img: 'vico-cena-caderno-folha.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'Texture and glow':       { img: 'vico-cena-caderno-folha.png' + V1, k: (window.vicoThemeI18n?.s_fcb92a4988cd ?? "FOR YOUR SKIN") },
      'SKIN1004':               { img: 'vico-cena-skin1004-centella.png' + V2, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Abib':                   { img: 'vico-cena-abib-heartleaf.png' + V2, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Biodance':               { img: 'vico-cena-biodance-biocollagen.png' + V2, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'numbuzin':               { img: 'vico-cena-numbuzin-no6.png' + V2, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Medicube':               { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'COSRX':                  { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Anua':                   { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Celimax':                { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Haruharu Wonder':        { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Dr. Althea':             { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_cabaea65f7be ?? "THE HOUSE") },
      'Madagascar Centella Ampoule': { img: 'vico-cena-skin1004-centella.png' + V2, k: (window.vicoThemeI18n?.s_5af7ed5af5e6 ?? "FEATURED") },
      'Advanced Snail 96 Essence':   { img: 'vico-cena-serum-textura.png' + V1, k: (window.vicoThemeI18n?.s_5af7ed5af5e6 ?? "FEATURED") },
      'Heartleaf Calming Essence':   { img: 'vico-cena-abib-heartleaf.png' + V2, k: (window.vicoThemeI18n?.s_5af7ed5af5e6 ?? "FEATURED") },
      'No.6 Deep Sleep Serum':       { img: 'vico-cena-numbuzin-no6.png' + V2, k: (window.vicoThemeI18n?.s_5af7ed5af5e6 ?? "FEATURED") },
      'Best sellers':                { img: 'vico-cena-rotina-manha.png' + V1, k: (window.vicoThemeI18n?.s_f546bc9620a0 ?? "VIÇO SELECTION") },
      'Comece por aqui':             { img: 'vico-cena-hero-seda.png' + V1, k: (window.vicoThemeI18n?.s_f546bc9620a0 ?? "VIÇO SELECTION") },
      'Start here':                  { img: 'vico-cena-hero-seda.png' + V1, k: (window.vicoThemeI18n?.s_f546bc9620a0 ?? "VIÇO SELECTION") },
      'Edições especiais':           { img: 'vico-edicao-deep-glow-set.jpg' + V3, k: (window.vicoThemeI18n?.s_f546bc9620a0 ?? "VIÇO SELECTION") },
      'Special editions':            { img: 'vico-edicao-deep-glow-set.jpg' + V3, k: (window.vicoThemeI18n?.s_f546bc9620a0 ?? "VIÇO SELECTION") },
      'Rotinas prontas':             { img: 'vico-presente-caixa-rosa.jpg' + V3, k: (window.vicoThemeI18n?.s_364a4e161601 ?? "THE ART OF GIFTING") },
      'Ready routines':              { img: 'vico-presente-caixa-rosa.jpg' + V3, k: (window.vicoThemeI18n?.s_364a4e161601 ?? "THE ART OF GIFTING") },
      'Até R$99':                    { img: 'vico-cena-textura-gel.png' + V1, k: (window.vicoThemeI18n?.s_364a4e161601 ?? "THE ART OF GIFTING") },
      'Up to R$99':                  { img: 'vico-cena-textura-gel.png' + V1, k: (window.vicoThemeI18n?.s_364a4e161601 ?? "THE ART OF GIFTING") },
      'Como escolher seu produto':   { img: 'vico-cena-caderno-folha.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'How to choose your product':  { img: 'vico-cena-caderno-folha.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'A ordem da rotina':           { img: 'vico-cena-rotina-manha.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'Routine order':               { img: 'vico-cena-rotina-manha.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'O que não misturar':          { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'What not to mix':             { img: 'vico-cena-caderno-marmore.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'Ativos de A a Z':             { img: 'vico-cena-serum-textura.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") },
      'Actives A to Z':              { img: 'vico-cena-serum-textura.png' + V1, k: (window.vicoThemeI18n?.s_b7c6f9f2d52f ?? "VIÇO ROUTINE") }
    };
    MAPA['The Routine Order'] = MAPA['Routine order'];
    MAPA['Actives from A to Z'] = MAPA['Actives A to Z'];
    MAPA['Ready-made routines'] = MAPA['Ready routines'];
    if (MAPA["Cleansing"]) MAPA["Limpieza"] = MAPA["Cleansing"];
    if (MAPA["Toners and essences"]) MAPA["Tónicos y esencias"] = MAPA["Toners and essences"];
    if (MAPA["Toners and essences"]) MAPA["Tónico y esencia"] = MAPA["Toners and essences"];
    if (MAPA["Serums and treatments"]) MAPA["Sérums y tratamientos"] = MAPA["Serums and treatments"];
    if (MAPA["Hydration and barrier"]) MAPA["Hidratación y barrera"] = MAPA["Hydration and barrier"];
    if (MAPA["Masks"]) MAPA["Mascarillas"] = MAPA["Masks"];
    if (MAPA["Exfoliation"]) MAPA["Exfoliación"] = MAPA["Exfoliation"];
    if (MAPA["Oily skin and pores"]) MAPA["Piel grasa y poros"] = MAPA["Oily skin and pores"];
    if (MAPA["Sensitive skin and redness"]) MAPA["Piel sensible y enrojecimiento"] = MAPA["Sensitive skin and redness"];
    if (MAPA["Texture and glow"]) MAPA["Textura y luminosidad"] = MAPA["Texture and glow"];
    if (MAPA["Start here"]) MAPA["Empieza aquí"] = MAPA["Start here"];
    if (MAPA["Special editions"]) MAPA["Ediciones especiales"] = MAPA["Special editions"];
    if (MAPA["Ready routines"]) MAPA["Rutinas listas"] = MAPA["Ready routines"];
    if (MAPA["Up to R$99"]) MAPA["Hasta R$99"] = MAPA["Up to R$99"];
    if (MAPA["How to choose your product"]) MAPA["Cómo elegir tu producto"] = MAPA["How to choose your product"];
    if (MAPA["Routine order"]) MAPA["El orden de la rutina"] = MAPA["Routine order"];
    if (MAPA["What not to mix"]) MAPA["Qué no combinar"] = MAPA["What not to mix"];
    if (MAPA["Actives A to Z"]) MAPA["Activos de la A a la Z"] = MAPA["Actives A to Z"];
    if (MAPA["Best sellers"]) MAPA["Explora la selección"] = MAPA["Best sellers"];
    var menuLookup = {};
    function normalizeMenuLabel(label) {
      return label.trim().toLowerCase().replace(/\s*&\s*/g, ' and ').replace(/\s+/g, ' ');
    }
    Object.keys(MAPA).forEach(function (t) {
      menuLookup[normalizeMenuLabel(t)] = MAPA[t];
      var i = new Image(); i.src = CDN + MAPA[t].img;
    });

    function liga(painel) {
      var card = painel.querySelector('.promotion');
      if (!card) return;
      var img = card.querySelector('img');
      var titulo = card.querySelector('.mega-menu__custom-title');
      var texto = card.querySelector('.mega-menu__custom-text');
      var links = card.querySelectorAll('a');
      if (!img) return;
      painel.querySelectorAll('a.mega-menu__link').forEach(function (a) {
        var chave = a.textContent.trim();
        var m = MAPA[chave] || menuLookup[normalizeMenuLabel(chave)];
        if (!m) return;
        function troca() {
          img.style.opacity = '0.25';
          window.setTimeout(function () {
            img.src = CDN + m.img;
            img.alt = chave;
            if (titulo) titulo.textContent = chave;
            if (texto) texto.textContent = m.k;
            links.forEach(function (l) { l.href = a.href; });
            img.style.opacity = '1';
          }, 90);
        }
        a.addEventListener('mouseenter', troca);
        a.addEventListener('focusin', troca);
      });
      if (img) img.style.transition = 'opacity .18s ease';
    }
    document.querySelectorAll('.mega-menu__content').forEach(liga);
  } catch (e) { /* menu segue estático — nada quebra */ }
})();
